import React, { useEffect } from 'react';

import { useSnackbar, SnackbarAction } from 'notistack';

import { Button } from '@mui/material';

import { useAppSelector } from 'hooks';

const NotificationProvider: React.FunctionComponent = ({}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const { lastMessage } = useAppSelector((state) => state.websocket);
    const { lastAntennaUpdate, lastGroundStationUpdate, list } = useAppSelector(
        (state) => state.antennas,
    );

    const action: SnackbarAction = (snackbarId) => (
        <Button variant="text" onClick={() => closeSnackbar(snackbarId)}>
            Dismiss
        </Button>
    );

    useEffect(() => {
        if (lastMessage)
            enqueueSnackbar(`${lastMessage.from}: ${lastMessage.message}`, {
                title: lastMessage.from,
                variant: (lastMessage.status ?? 'default') as any,
                action,
            });
    }, [lastMessage]);

    useEffect(() => {
        if (lastAntennaUpdate) {
            const antenna = list.object?.find(
                ({ id }) => id === lastAntennaUpdate.antenna_id,
            );
            if (antenna) {
                const title = `${antenna.groundstation.name} Antenna #${antenna.id}`;
                if (lastAntennaUpdate.status === 'inactive') {
                    enqueueSnackbar(`${title} Is no longer Active`, {
                        title,
                        variant: 'warning',
                        action,
                    });
                } else {
                    enqueueSnackbar(
                        `${title} is now in status ${lastAntennaUpdate.status}`,
                        {
                            title,
                            variant: 'default',
                            action,
                        },
                    );
                }
            }
        }
    }, [lastAntennaUpdate]);

    useEffect(() => {
        if (lastGroundStationUpdate) {
            const groundstation = list.object?.find(
                ({ groundstation: gs }) => gs.id === lastGroundStationUpdate.id,
            );

            if (groundstation) {
                const title = `${groundstation.name}`;
                if (lastGroundStationUpdate.connection_id) {
                    enqueueSnackbar(`${title} has Connected`, {
                        title,
                        variant: 'success',
                        action,
                    });
                } else {
                    enqueueSnackbar(`${title} has Disconnected`, {
                        title,
                        variant: 'warning',
                        action,
                    });
                }
            }
        }
    }, [lastGroundStationUpdate]);

    return <></>;
};

NotificationProvider.displayName = 'NotificationProvider';
export default NotificationProvider;
